import { PASSWORD_RULE } from 'constants/password';

export const getPasswordRegExp = ({ from, to }: { from: number; to: number } = PASSWORD_RULE.length) =>
    new RegExp(`^[a-zA-Z\\d$#@!%^&*?]{${from},${to}}$`);
